const key = 'ijbk4Yf3rCPbt7WMXuGI';

function keyfunction() {
  return key;
}

export default keyfunction;